// Meta (Facebook) Pixel helper — safe wrapper around window.fbq.
// The base pixel script is injected in /public/index.html and initializes
// with Pixel ID 1401886122154219 on first load.
//
// All exports are no-ops when window.fbq is not available (SSR, ad-blockers,
// dev environments). This keeps the app resilient.

const hasFbq = () => typeof window !== "undefined" && typeof window.fbq === "function";

export const trackPageView = () => {
  if (!hasFbq()) return;
  try {
    window.fbq("track", "PageView");
  } catch (_e) {
    /* noop */
  }
};

export const trackViewContent = ({ id, name, price, currency = "EUR", contentType = "product" }) => {
  if (!hasFbq()) return;
  try {
    window.fbq("track", "ViewContent", {
      content_ids: id ? [String(id)] : undefined,
      content_name: name,
      content_type: contentType,
      value: typeof price === "number" ? Number(price.toFixed(2)) : undefined,
      currency,
    });
  } catch (_e) {
    /* noop */
  }
};

export const trackAddToCart = ({ id, name, price, currency = "EUR", quantity = 1 }) => {
  if (!hasFbq()) return;
  try {
    const value = typeof price === "number" ? Number((price * quantity).toFixed(2)) : undefined;
    window.fbq("track", "AddToCart", {
      content_ids: id ? [String(id)] : undefined,
      content_name: name,
      content_type: "product",
      value,
      currency,
      num_items: quantity,
    });
  } catch (_e) {
    /* noop */
  }
};

export const trackInitiateCheckout = ({ ids = [], value, currency = "EUR", numItems }) => {
  if (!hasFbq()) return;
  try {
    window.fbq("track", "InitiateCheckout", {
      content_ids: ids.map(String),
      content_type: "product",
      value: typeof value === "number" ? Number(value.toFixed(2)) : undefined,
      currency,
      num_items: numItems,
    });
  } catch (_e) {
    /* noop */
  }
};

export const trackPurchase = ({ ids = [], value, currency = "EUR", orderId, numItems }) => {
  if (!hasFbq()) return;
  try {
    window.fbq(
      "track",
      "Purchase",
      {
        content_ids: ids.map(String),
        content_type: "product",
        value: typeof value === "number" ? Number(value.toFixed(2)) : undefined,
        currency,
        num_items: numItems,
      },
      orderId ? { eventID: String(orderId) } : undefined,
    );
  } catch (_e) {
    /* noop */
  }
};
